import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import KitchenPage from 'modules/restaurant/kitchen/KitchenPage';

export default function DashRestaurantKitchen() {
    return (
        <DashContainer title='Pedidos'>
            <KitchenPage />
        </DashContainer>
    );
}
